import {
  Gauge,
  KeyRound,
  LayoutDashboard,
  ScrollText,
  Timer,
  Trophy,
  Upload,
  User,
  Users,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Matches child routes too, e.g. `/sessoes/abc` lights up "Sessões". */
  matchPrefix?: boolean;
}

/**
 * The five primary destinations. Five is the hard cap for a thumb-reachable
 * bottom bar; anything else lives inside a section.
 */
export const PRIMARY_NAV: NavItem[] = [
  { to: '/', label: 'Início', icon: Gauge },
  { to: '/importar', label: 'Importar', icon: Upload, matchPrefix: true },
  { to: '/sessoes', label: 'Sessões', icon: Timer, matchPrefix: true },
  { to: '/ranking', label: 'Ranking', icon: Trophy, matchPrefix: true },
  { to: '/perfil', label: 'Perfil', icon: User, matchPrefix: true },
];

export const ADMIN_NAV: NavItem[] = [
  { to: '/admin', label: 'Visão geral', icon: LayoutDashboard },
  { to: '/admin/usuarios', label: 'Usuários', icon: Users, matchPrefix: true },
  { to: '/admin/sessoes', label: 'Sessões', icon: Timer, matchPrefix: true },
  { to: '/admin/auditoria', label: 'Auditoria', icon: ScrollText, matchPrefix: true },
  { to: '/admin/logins', label: 'Logins', icon: KeyRound, matchPrefix: true },
];

/** Longest-prefix match wins, so `/sessoes/:id` still resolves to "Sessões". */
const TITLES: Array<[string, string]> = [
  ['/', 'Início'],
  ['/importar', 'Importar'],
  ['/sessoes', 'Sessões'],
  ['/comparar', 'Comparar voltas'],
  ['/pista-3d', 'Pista 3D'],
  ['/ranking', 'Ranking'],
  ['/perfil', 'Perfil'],
  ['/admin', 'Visão geral'],
  ['/admin/usuarios', 'Usuários'],
  ['/admin/sessoes', 'Sessões'],
  ['/admin/auditoria', 'Auditoria'],
  ['/admin/logins', 'Logins'],
];

export function pageTitle(pathname: string): string {
  let best = 'MychronoHelper';
  let bestLength = -1;
  for (const [prefix, title] of TITLES) {
    const matches = prefix === '/' ? pathname === '/' : pathname === prefix || pathname.startsWith(`${prefix}/`);
    if (matches && prefix.length > bestLength) {
      best = title;
      bestLength = prefix.length;
    }
  }
  return best;
}

export function isNavActive(item: NavItem, pathname: string): boolean {
  if (item.to === '/' || item.to === '/admin') return pathname === item.to;
  if (item.matchPrefix) return pathname === item.to || pathname.startsWith(`${item.to}/`);
  return pathname === item.to;
}
